export interface IStorageGameData {
  currentGame: TCurrentGame,
  stat: TStat
}

export enum GameStatus {
  VICTORY = 'victory',
  LOST = 'lost',
}

type TCurrentGame = {
  gameID: number | undefined,
  guesses: string[]
}

export type TStat = {
  guesses: number[];
  Played: number;
  Win: number;
  CurrentStreak: number;
  MaxStreak: number;
  lastGameStatus: GameStatus;
  lastPlayedDate: string;
};

export type TBrand = {
  "logoUrl": string,
  "name": string,
  "category": string[],
  "id": number
};
